<template>
  <div class="warning">
    <div class="warning__box">
        <h1>{{ titel }}</h1>
        <br>
        <p>{{ tekst }}</p>
        <div class="warning__box__buttons">
            <p class="button" @click="$emit('actionWarning1', this.$props.btn1)">{{ btn1 }}</p>
            <p class="button button_2" @click="$emit('actionWarning2', this.$props.btn2)">{{ btn2 }}</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props:['titel', 'tekst', 'btn1', 'btn2'],
}
</script>